// extracted by mini-css-extract-plugin
module.exports = {"root":"_752b34","item":"_bc0262","anchor":"_3347b0"};